export default __webpack_public_path__ + "static/media/vasooli-money.4e586bf9.md";